var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"tf-logo",attrs:{"to":"/"}},[_vm._v(" 🌄 Town Faker ")])}
var staticRenderFns = []

export { render, staticRenderFns }